//WE.Flow.Html.Contracts.Manifests.TestManifest

export class TestManifest {
    name: string = "";
    sourcePath: string = "";
    compile: boolean = false;
    pabloIdentifier: string = "";
}
